import React from 'react';
import AuthProvider from 'components/AuthProvider/AuthProvider';
import {QueryClient, QueryClientProvider} from 'react-query';
import ReactNotification from 'react-notifications-component';
import Router from './Router/Router';

import 'react-notifications-component/dist/theme.css';

export const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactNotification />
      <AuthProvider>
        <Router />
      </AuthProvider>
    </QueryClientProvider>
  );
};
export default App;
